import { CONNECTION } from "../../config/Connections";
import { CONFIG_ } from "../../config/Config";
import { successnotify, warningnotify } from "../../components/ToasNotif/Toast";
import { __openModal } from "../Modal";

var get = "/typefamily";
var post = "/typefamily";
export const actGetDataTypefamily = () => {
  return (dispatch) => {
    let config = CONFIG_({ url: get, method: "GET" });
    dispatch({ type: "LOADING_TYPEFAMILY" });
    CONNECTION(config)
      .then((response) => {
        const { status, data } = response;
        if (status === 200) {
          return dispatch({
            type: "SUCCESS_TYPEFAMILY",
            message: "Success get data",
            data: data,
            code: status,
          });
        }
        return dispatch({ type: "ERROR_TYPEFAMILY", message: "failed" });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_TYPEFAMILY",
          message: "Network error..",
        });
      });
  };
};

export const actPostDataTypefamily = (params) => {
  return (dispatch) => {
    let config = CONFIG_({ url: post, data: params, method: "POST" });
    dispatch({ type: "LOADING_TYPEFAMILY" });
    CONNECTION(config)
      .then((response) => {
        const { status } = response;
        if (status === 200) {
          successnotify("Type family has been created");
          dispatch(__openModal({ modal: "MODAL_ADD_TYPEFAMILY", open: false }));
          return dispatch(actGetDataTypefamily());
        }
        warningnotify(response.message);
        return dispatch({ type: "ERROR_TYPEFAMILY", message: "failed" });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_TYPEFAMILY",
          message: "Network error..",
        });
      });
  };
};

export const actUpdateDataTypefamily = (params) => {
  return (dispatch) => {
    const { id } = params;
    let config = CONFIG_({ url: post + "/" + id, data: params, method: "PUT" });
    dispatch({ type: "LOADING_TYPEFAMILY" });
    CONNECTION(config)
      .then((response) => {
        const { status } = response;
        if (status === 200) {
          successnotify("Type family has been update");
          dispatch(
            __openModal({ modal: "MODAL_EDIT_TYPEFAMILY", open: false })
          );
          return dispatch(actGetDataTypefamily());
        }
        warningnotify(response.message);
        return dispatch({ type: "ERROR_TYPEFAMILY", message: "failed" });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_TYPEFAMILY",
          message: "Network error..",
        });
      });
  };
};

export const actDetailDataTypefamily = (params) => {
  return (dispatch) => {
    const { id } = params;
    let config = CONFIG_({ url: post + "/" + id, method: "GET" });
    dispatch({ type: "LOADING_TYPEFAMILY" });
    CONNECTION(config)
      .then((response) => {
        const { status } = response;
        if (status === 200) {
          return dispatch({
            type: "SUCCESS_TYPEFAMILY",
            message: "Success get data",
          });
        }
        return dispatch({ type: "ERROR_TYPEFAMILY", message: "failed" });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_TYPEFAMILY",
          message: "Network error..",
        });
      });
  };
};

export const actDeleteDataTypefamily = (params) => {
  return (dispatch) => {
    const { id } = params;
    let config = CONFIG_({ url: post + "/" + id, method: "DELETE" });
    dispatch({ type: "LOADING_TYPEFAMILY" });
    CONNECTION(config)
      .then((response) => {
        const { status } = response;
        if (status === 200) {
          successnotify("Type family has been deleted");
          return dispatch(actGetDataTypefamily());
        }
        warningnotify(response.message);
        return dispatch({ type: "ERROR_TYPEFAMILY", message: "failed" });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_TYPEFAMILY",
          message: "Network error..",
        });
      });
  };
};
